import React, {useEffect, useState} from 'react';
import {
  Grid,
  TextField, Stepper, Step, IconButton, Tooltip, InputAdornment, Link,
  Paper, Typography, Autocomplete, Box,
  Button, MenuItem, InputLabel,Select, FormControl, 
} from '@mui/material';


import accessLogService from '../../services/accessLogService'

import { useSelector,useDispatch } from 'react-redux';


import { DatePicker } from '@mui/x-date-pickers/DatePicker'
import { DateTimePicker } from '@mui/x-date-pickers/DateTimePicker'
//import LocalizationProvider from '@mui/lab/LocalizationProvider'
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider'
import {AdapterDateFns} from '@mui/x-date-pickers/AdapterDateFns';

import Card from '@mui/material/Card';
import CardHeader from '@mui/material/CardHeader';
//import CardMedia from '@mui/material/CardMedia';
import CardContent from '@mui/material/CardContent';
import CardActions from '@mui/material/CardActions';
import Avatar from '@mui/material/Avatar';


import CopyIcon from '@mui/icons-material/FileCopy';
import ZoomIcon from '@mui/icons-material/ZoomIn';
import VideoLibraryIcon from '@mui/icons-material/Terminal'
//import ZoomIcon from '@mui/icons-material/VideoLibrary';

import { format, set } from 'date-fns';

import {useAppAuthContext} from '../../utils/AppAuthContext'

import {usePlayContext} from '../../utils/PlayContext';

import { Navigate, useLocation, useNavigate, useParams } from 'react-router-dom';

import { selectAllHosts } from '../../store/userSlice';



import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import TablePagination from '@mui/material/TablePagination';

const categories = 	[
  'INVITATION',
  'VISITOR',
  'WALK_IN_REQUEST',
  'COURIER',
  'HOUSE_KEEPING',
  'ADMINISTRATION',
  'BATCH_JOB']
const actions = 	[
  'ALERTOVERSTAYJOB',
'APPROVE',
'CANCEL',
'CANCEL_REOCCURENCE',
'CHECK_IN',
'CHECK_OUT',
'CLEANUPJOB',
'CLEANUPVISITORHISTORY',
'CLEAR_INVITATION',
'CLEAR_VISITOR_HISTORY',
'CLEAR_VISITOR_OT',
'CLEAR_VISITOR_PROFILE',
'DELETE',
'DELETE_REOCCURENCE',
'ENROL',
'EXPIREDINVITATION',
'INVITE',
'PROFILE',
'REJECT',
'REQUEST',
'UPDATEWALKINREQUESTJOB',
]



const AuditLogPage = () => {

  const navigate = useNavigate()
  
  const {userInfo} = useAppAuthContext()

  const managedHosts = useSelector(selectAllHosts)
  
  const {
      setOp,
      status, setStatus, appTitle, setAppTitle, 
      errorMessage, setErrorMessage, errorTitle, setErrorTitle,
      setTenantLogo, openSnackToast
    }=usePlayContext()


  const dispatch = useDispatch()
  
        

  const [host, setHost] = React.useState('');
  

  const [description, setDescription] = React.useState('')

  const [startDateTime, setStartDateTime] = useState(null);
  const [endDateTime, setEndDateTime] = useState(null);
  const [category, setCategory] = useState('');
  const [action, setAction] = useState('');

  const [resetPage, setResetPage] = React.useState(false);
  const [queryClicked, setQueryClicked] = React.useState(true);
  const [tableData, setTableData] = React.useState([]);
  const [pageSize, setPageSize] = React.useState(10);
  const [pageNumber, setPageNumber] = React.useState(0);
  const [totalRecords, setTotalRecords] = React.useState(0);
  const [searchCriteria, setSearchCriteria] = React.useState({});
  
  const [endDateTimeError, setEndDateTimeError] = useState(''); 

  const fetcPagedhData = async(searchCriteria)=>{
    setStatus('processing')
    try
    {
      let response = await accessLogService.queryAuditLog(searchCriteria)
    
      let data = response.data;
      console.log(data)


      let contents = data.content;

      // if (contents && contents.length>0)
      // {
      //     contents = contents.map(
      //         x=>{
      //           let y={...x}

      //           if (x.before)
      //           {
      //               y.before = JSON.parse(x.before)
      //           }
      //           if (x.after)
      //           {
      //               y.after = JSON.parse(x.after)
      //           }
      //           return y;

      //         }
            
      //       )
      // }
      
      
      setTableData(contents)
      setTotalRecords(data.totalElements)
      setStatus('success')

    }
    catch (ex)
    {
      setStatus('error')
      setErrorMessage("Network retrival error")
    }

  }
  
  useEffect(() => {
    setAppTitle(  ['Transaction Log','Audit Log'])
    setErrorMessage('')
    setErrorTitle('')

    if (queryClicked)
    {
        let x={...searchCriteria, pageSize,pageNumber}  
        fetcPagedhData(x);

    }

    return () => {

    }

  }, [searchCriteria, pageNumber, pageSize, queryClicked])

  const doReset = ()=>
  {
      setHost('')
      setDescription('')
      setCategory('')
      setAction('')
      setEndDateTimeError('')
      setStartDateTime(null)
      setEndDateTime(null)
      setQueryClicked(false)
      setSearchCriteria({})
      setTableData([])
      setTotalRecords(0)
      setPageNumber(0)
  }
 
  const doSearch = async ()=>
  {
      let errNo=0
      let tmp1 = Date.parse(startDateTime);
      let tmp2 = Date.parse(endDateTime);

      if(resetPage)
        setPageNumber(0);
      let postBody={
          
          action,
          description,
          category,
          pageNumber,
          pageSize,
          host,

      }

      if (!isNaN(tmp2) && !isNaN(tmp1) && tmp2<tmp1 )
      {
        errNo++;
        setEndDateTimeError('End Time cannot be earlier than Start Time')    
          
      }     


      let dt1 = null;
      let dt2=null
      if (!isNaN(tmp1))
      {
          dt1=new Date(startDateTime.getFullYear(), startDateTime.getMonth(),startDateTime.getDate())
          tmp1=dt1.getTime();
          postBody.startTm=format(dt1, "yyyy-MM-dd'T'HH:mm:ss.SSS");
          
          
      }
      if (!isNaN(tmp2))
      {
          dt2=new Date(endDateTime.getFullYear(), endDateTime.getMonth(),endDateTime.getDate(), 23, 59,59,999)
          //alert(dt2)
          tmp2=dt2.getTime();
          //postBody.endTm=dt2.toISOString();
      
          postBody.endTm=format(dt2, "yyyy-MM-dd'T'HH:mm:ss.SSS");
      }

      //alert(JSON.stringify(postBody))


      if (!isNaN(tmp1)  && !isNaN(tmp2) && tmp2 <tmp1 )
      {
        console.log("Invalid Date Range")  

      }
      console.log(startDateTime)

      console.log(dt1)
      console.log(dt2)

      
      
      console.log("xx-"+tmp1)
      console.log(tmp2)
      
      if (errNo>0) return
      
      setQueryClicked(true)
      setSearchCriteria(postBody)
      
  }

  const handleChangePage = (event, newPage) => {
    //alert('New Page--'+newPage)
    setPageNumber(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setPageSize(event.target.value);
    //alert('New Page Size--'+event.target.value)
    setPageNumber(0);
  };

  return (
    <Box sx={{p:1}}>
      
      <Card sx={{width:'100%', m:0, p:0,  border:1}}  raised>
            
      <CardContent sx={{mx:1, mt:1, mb:0, pt:1, pb:0}}>
        <Grid
          container 
          spacing={1}
          direction={'row'}
          columns={28}
        >
       
          <Grid item xs={24} sm={12}    md={8} lg={4} >
                <LocalizationProvider dateAdapter={AdapterDateFns}>
                    <DatePicker 
                       disableFuture
                      label="Start Date"
                      onChange={(newValue) => {  setStartDateTime(newValue);}}
                      value={startDateTime}

                      inputFormat="dd/MM/yyyy"

                      renderInput={(props) => 
                      <TextField {...props} 
                          
                          fullWidth 
                          size='small'
                          />}
                      
                      />
                  </LocalizationProvider>
             </Grid>
              <Grid item xs={24} sm={12}    md={8} lg={4} >
                <LocalizationProvider dateAdapter={AdapterDateFns}>
                  <DatePicker 
                      inputFormat="dd/MM/yyyy"
                      disableFuture
                      renderInput={(props) => 
                      <TextField {...props} 
                          
                          size='small'
                          fullWidth 
                          error={Boolean(endDateTimeError)}
                          helperText={Boolean(endDateTimeError)? endDateTimeError : '' }
                          />}
                      label="End Date"
                      value={endDateTime}
                      onChange={(newValue) => {  setEndDateTime(newValue);}}
                  />
                  </LocalizationProvider>
              </Grid>
          

              {
                  userInfo.idTokenClaims.roles.includes('ADMIN') &&
                  <React.Fragment>
                      <Grid item xs={24} sm={12}    md={8} lg={4} >
                          <FormControl   fullWidth size='small'>
                            <InputLabel id="id_host_label" >Host</InputLabel>
                                <Select
                                    
                                    labelId="id_host_label"
                                    id="id_host"
                                    value={host}
                                    label="Host"
                                    onChange={(e)=>setHost(e.target.value)}
                                    
                                    >
                                  <MenuItem value={''}>ALL</MenuItem>
                                  {
                                      managedHosts && managedHosts.map( (u)=>
                                      <MenuItem key={u.userName} value={u.userName}>{u.fullName}</MenuItem>
                                      )
                                  }
                              </Select>
                                    
                        </FormControl>
                      </Grid>
                  </React.Fragment>

              }
              <Grid item xs={24} sm={12}    md={8} lg={4} >
                  <FormControl   fullWidth size='small'>
                    <InputLabel id="id_category_label" >Category</InputLabel>
                        <Select
                            
                            labelId="id_category_label"
                            id="id_category"
                            value={category}
                            label="Category"
                            onChange={(e)=>{setCategory(e.target.value);setResetPage(true)}}
                            
                            >
                          <MenuItem value={''}>ALL</MenuItem>
                          
                          {
                              categories.map( (ct)=>
                                (<MenuItem key={ct} value={ct}>{ct}</MenuItem>)
                              )
                          }
                          
                      </Select>
                                
                    </FormControl>
              
            </Grid>
            <Grid item xs={24} sm={12}    md={8} lg={4} >
                  <FormControl   fullWidth size='small'>
                    <InputLabel id="id_action_label" >Action</InputLabel>
                        <Select
                            
                            labelId="id_action_label"
                            id="id_action"
                            value={action}
                            label="Action"
                            onChange={(e)=>{setAction(e.target.value);setResetPage(true)}}
                            
                            >
                          <MenuItem value={''}>ALL</MenuItem>
                          
                          {
                              actions.map( (ct)=>
                                (<MenuItem key={ct} value={ct}>{ct}</MenuItem>)
                              )
                          }
                          
                      </Select>
                                
                    </FormControl>
              
            </Grid>
            <Grid item xs={24} sm={12}    md={8} lg={4} >
                    
                <TextField 
                      size='small'
                        fullWidth  variant='outlined'
                    value={description}
                    onChange={e=>{setDescription(e.target.value);setResetPage(true);}}
                    id='id_description'
                    label='Description'
                  />
            </Grid>
            <Grid item xs={20} sm={10} md={4} lg={4} >
              <Box sx={{mt:1,display:'flex', width:'100%', justifyContent: 'space-around'}}>

                  <Button variant="outlined"  
					color='primary'  
                    onClick={doSearch}
                  > Search</Button>
                  <Button variant="outlined"  color='info'  
                    onClick={doReset}
                  > Clear</Button>

              </Box>
          </Grid>                          
        </Grid>

        </CardContent>
        </Card>
        <Box sx={{my:1}}>
          <TableContainer component={Paper} >
            <Table aria-label="collapsible table" size='small' >
            <TableHead>
                <TableRow sx={{bgcolor:'#6495ED'}}>
                    <TableCell align="center" style={{border: '1px solid LightGray', fontWeight: 600}}>ID</TableCell>
                    <TableCell align="center" style={{border: '1px solid LightGray', fontWeight: 600}}>TIME</TableCell>
                    <TableCell align="center" style={{border: '1px solid LightGray', fontWeight: 600}}>CATEGORY</TableCell>
                    <TableCell align="center" style={{border: '1px solid LightGray', fontWeight: 600}}>ACTION</TableCell>

                    <TableCell align="center" style={{border: '1px solid LightGray', fontWeight: 600}}>HOST</TableCell>
                    <TableCell align="center" style={{border: '1px solid LightGray', fontWeight: 600}}>DESCRIPTION</TableCell>
                    
                    
                    <TableCell align="center"  style={{border: '1px solid LightGray', fontWeight: 600}}>BEFORE</TableCell>
                    <TableCell align="center"  style={{border: '1px solid LightGray', fontWeight: 600}}>AFTER</TableCell>
                    <TableCell align="center" style={{border: '1px solid LightGray', fontWeight: 600}}>USER</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  { tableData && tableData.length>0 &&
                      tableData.map((row, i)=>

                        <TableRow key={row.id} 
                            >
      
                              <TableCell  style={{border: '1px solid LightGray', whiteSpace:'nowrap'}}>
                                  {row.id}
                              </TableCell>
                              <TableCell  style={{border: '1px solid LightGray', whiteSpace:'nowrap'}}>
                                  {row.logTm}
                              </TableCell>
                              <TableCell  style={{border: '1px solid LightGray', whiteSpace:'nowrap'}}>
                                  {row.category}
                              </TableCell>
                              <TableCell  style={{border: '1px solid LightGray', whiteSpace:'nowrap'}}>
                                  {row.action}
                              </TableCell>
                              <TableCell  style={{border: '1px solid LightGray', whiteSpace:'nowrap'}}>
                                  {row.host}
                              </TableCell>
                              <TableCell  style={{border: '1px solid LightGray', }}>
                                  
                                  {
                                      row.description &&
                                   
                                   <Box sx={{display:'flex', justifyContent:'space-between'}}>
                                          <Tooltip  placement="left-start"
                                          title={
                                            <Typography varint='h5' component="p" color={'#000000'}  
                                                sx={{bgcolor:'#EEEEEE', p:4, minWidth:700}}>
                                            <code>{row.description}</code></Typography>}

                                            >
                                              <Typography variant='body2'>
                                                {row.description.length>60? row.description.substring(0,60)+" ...":  row.description}

                                                </Typography>
                                          </Tooltip>
                                          <Tooltip  placement="left-start" title='Copy to ClipBoard'>

                                              <IconButton size='small' color='primary'
                                                sx={{ml:1}}
                                                onClick={() => {
                                                  navigator.clipboard.writeText(row.description)
                                                  openSnackToast('Description copied', 'info')
                                                  }}
                                              
                                              >
                                                
                                                <CopyIcon size='small' sx={{fontSize:20}}/>
                                              
                                              </IconButton>
                                              </Tooltip>
                                      </Box>
                                  }
                                  
                              </TableCell>
                                                      
                              <TableCell  style={{border: '1px solid LightGray', whiteSpace:'nowrap'}}>
                                  { 
                                    row.before && 
                                    
                                    <Box sx={{display:'flex', justifyContent:'space-between', width:'100%'}}>
                                        <Tooltip  placement="left"
                                          title={
                                            <Typography varint='h6' component="p" color={'#000000'}  
                                                sx={{bgcolor:'#FDFDFE', p:2, minWidth:600}}>
                                            <code>{row.before}</code></Typography>}
                                            >
                                              <Button variant="outlined"size='small' 
											  color='primary'
                                                    sx={{textTransform:'none', mr:2}}
                                                  >
                                                      View...
                                              </Button>
                                         </Tooltip>
                                    
                                      <Tooltip  placement="left-start" title='Copy to ClipBoard'>

                                        <IconButton size='small' color='primary'
                                          onClick={() => {
                                            navigator.clipboard.writeText(row.before)
                                            openSnackToast('Information copied', 'info')
                                            }}
                                        
                                        >
                                          
                                          <CopyIcon size='small' />
                                        
                                        </IconButton>
                                        </Tooltip>
                                    </Box>
                                    
                                  }
                                  
                              </TableCell>
                              <TableCell  style={{border: '1px solid LightGray', whiteSpace:'nowrap'}}>
                              { 
                                    row.after && 
                                    
                                    <Box sx={{display:'flex', justifyContent:'space-between', width:'100%'}}>
                                        <Tooltip  placement="left"
                                          title={
                                            <Typography varint='h6' component="p" color={'#000000'}  
                                                sx={{bgcolor:'#FDFDFE', p:2, minWidth:600}}>
                                            <code>{row.after}</code></Typography>}
                                            >
                                              <Button variant="outlined"size='small' color='primary'
                                                    sx={{textTransform:'none', mr:2}}
                                                  >
                                                      View...
                                              </Button>
                                         </Tooltip>
                                    
                                      <Tooltip  placement="left-start" title='Copy to ClipBoard'>

                                        <IconButton size='small' color='primary'
                                          onClick={() => {
                                            navigator.clipboard.writeText(row.after)
                                            openSnackToast('Information copied', 'info')
                                            }}
                                        
                                        >
                                          
                                          <CopyIcon size='small' />
                                        
                                        </IconButton>
                                        </Tooltip>
                                    </Box>
                                    
                                  }
                              </TableCell>
                              
                              <TableCell  style={{border: '1px solid LightGray', whiteSpace:'nowrap'}}>
                                  {row.userName}
                              </TableCell>
                             
                        </TableRow>

                      )

                  }

              </TableBody>
      
      
            </Table>
        </TableContainer>
        <TablePagination
            rowsPerPageOptions={[10, 20, 50]}
            component="div"
       
        
        showFirstButton={true}
        showLastButton={true}
              count={totalRecords}
              rowsPerPage={pageSize}
              page={pageNumber}
              onPageChange={handleChangePage}
              onRowsPerPageChange={handleChangeRowsPerPage}
              //ActionsComponent={TablePaginationActions}
      />
   </Box>

       
      
  </Box>
    
  );
};


export default AuditLogPage;
